import { getSession } from 'next-auth/react'

/**
 * The current session, read fresh from the server (next-auth refreshes the
 * access token there when it is about to expire).
 *
 * `broadcast: false` matters. next-auth's default getSession() tells every
 * other open tab of the app to refetch its session too. The API client calls
 * this before every request, so with the 20-45 s background polls a second tab
 * was refetching its session every few seconds, and pages tied to the session
 * reloaded under the user (RELI UAT: "the system refreshes every ~30 seconds
 * and we lose our work").
 */
export function getFreshSession() {
  return getSession({ broadcast: false })
}
